import React from 'react';
import TableComponent from './TableComponent'
import TableTabs from './TableTabs';

function MultiDataGrid({ gridData, displaySettings }) {
  const freq_table = gridData.freq_table;
  const tabs = [];

  if (gridData?.Nets) {
    freq_table.statements.filter(x => x.index <= -5555).forEach(stat => {
      tabs.push({
        key: `summary-${stat.index}`,
        label: stat.label ? `Summary - ${stat.label}` : `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={stat.index}>
            <h1>{gridData.Qtitle} - Summary {stat.label}</h1>
            <TableComponent cols={freq_table.cols} statements={freq_table.ratings} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"ratingIndex"} lvl3={"rowIndex"} lvl4={"statementIndex"}
              flt3={1} flt4={stat.index}
              displaySettings={displaySettings}
              szr={!!gridData.szr}
            />
          </React.Fragment>
        )
      });
    });
  }

  if (freq_table) {
    freq_table.ratings.filter(x => x.index > 0).forEach(statement => {
      tabs.push({
        key: `rating-${statement.index}`,
        label: statement.label || `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={statement.index}>
            <h5>{gridData.Qtitle} - {statement.label}</h5>
            <TableComponent cols={freq_table.cols} statements={freq_table.rows} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"rowIndex"} lvl3={"statementIndex"} lvl4={"ratingIndex"}
              flt3={1} flt4={statement.index}
              displaySettings={displaySettings}
              szr={!!gridData.szr}
            />
          </React.Fragment>
        )
      });
    });

    freq_table.rows.filter(x => x.index > 0).forEach(statement => {
      tabs.push({
        key: `row-${statement.index}`,
        label: statement.label || `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={statement.index}>
            <h5>{gridData.Qtitle} - {statement.label}</h5>
            <TableComponent cols={freq_table.cols} statements={freq_table.ratings} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"ratingIndex"} lvl3={"statementIndex"} lvl4={"rowIndex"}
              flt3={1} flt4={statement.index}
              displaySettings={displaySettings}
              szr={!!gridData.szr}
            />
          </React.Fragment>
        )
      });
    });
  }

  return (
    <div className="App">
      <h5>{gridData.Qtitle}</h5>
      <TableTabs tabs={tabs} />
    </div>
  );
}

export default MultiDataGrid;
